/**
 * Grid-settings entry in the data-grid toolbar.
 *
 * One Tune control, one click, covering everything a user can change about what
 * a grid shows them. Where the grid can offer its own configure dialog this
 * opens that; on a grid that cannot, it falls back to the column chooser the
 * data grid provides, so every list keeps a working control either way.
 *
 * Contains:
 * - GridSettingsButton — the Tune button (default export)
 */
import TuneIcon from '@mui/icons-material/Tune';
import React from 'react';

import ToolbarIconButton from './ToolbarIconButton';

/**
 * @param {object} props
 * @param {string} props.tooltip - accessible name and hover label for the button
 * @param {() => void} props.onClick - opens the configure dialog, or the
 *   built-in column chooser on a grid that has no dialog to offer
 * @returns {React.ReactElement}
 */
export default function GridSettingsButton({ tooltip, onClick }) {
  return (
    <ToolbarIconButton tooltip={tooltip} onClick={onClick}>
      <TuneIcon sx={{ fontSize: 18 }} />
    </ToolbarIconButton>
  );
}
